var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"card"},[_c('v-card-text',{staticClass:"pa-2"},[_c('pie-chart',{attrs:{"data":_vm.data,"legend":"right","donut":true,"title":"blocked in country"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/statistics/LocationStatistic.vue?vue&type=template&id=c33c8260&
// module id = null
// module chunks = 